import React from 'react';
import { useIntl } from 'react-intl';

import { hasValue } from '@/shared/utils/validation';

import {
  DescriptionProductOfComposition,
  InternalList,
  Underline,
  UnderlineInnerList,
} from './parts';
import { NutritionalTree } from './types';

interface NutritionalItemProps {
  item: NutritionalTree[number];
  sumByNesting?: number;
}

const NutritionalItem: React.FC<NutritionalItemProps> = ({ item, sumByNesting = 1 }) => {
  const { formatMessage } = useIntl();
  const notAvailableLabel = formatMessage({
    id: 'Menus.Filters.MealCalculator.Labels.NotAvailable',
  });

  // only for the "Includes Added Sugars" property for task 29519
  const valueItem =
    hasValue(item.Value) || item.Name !== 'Includes Added Sugars'
      ? `${item.Value || ''} ${item.Unit || ''}`
      : notAvailableLabel;
  const isFirstNesting = sumByNesting === 1;
  const isSubList = !!(item.SubList && item.SubList.length > 0);

  return (
    <DescriptionProductOfComposition
      {...(!isFirstNesting && { fontWeight: 'normal' })}
      data-nesting={sumByNesting}
    >
      {item.Name}
      <span>{valueItem}</span>

      {isSubList && (
        <InternalList>
          {item.SubList!.map((subItem) => (
            <React.Fragment key={subItem.Name}>
              <NutritionalItem item={subItem} sumByNesting={sumByNesting + 1} />
            </React.Fragment>
          ))}
        </InternalList>
      )}
      {!isSubList &&
        (isFirstNesting ? (
          <Underline />
        ) : (
          <UnderlineInnerList
            {...(sumByNesting > 1 && {
              num: sumByNesting - 1,
            })}
          />
        ))}
    </DescriptionProductOfComposition>
  );
};

export default NutritionalItem;
